function AwardMobile() {
  return (
    <section id="awards" className="pt-[50px]">
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-xl font-bold mb-8">COMPETITIONS</p>
        </div>

        <div className="flex flex-col mb-8">
          <p className="text-gray-4 text-[15px] mb-2">Oct 2024</p>
          <p className="font-normal mb-2">
            Third prize in AI Challenge Ho Chi Minh City - Event Retrieval from
            Visual Data (5/800)
          </p>
          <p className="text-[15px] text-gray-4">
            Our team of 5 built a system to search for specific event frames
            within 1,400-video dataset.
          </p>
        </div>

        <div className="flex flex-col mb-8">
          <p className="text-gray-4 text-[15px] mb-2">May 2024</p>
          <p className="font-normal mb-2">
            Top 15 CodeRace 2024 Autonomous Driving - Bosch Global Vietnam
          </p>
          <p className="text-[15px] text-gray-4">
            Solved Adaptive Cruise Control problems for highway driving.
          </p>
        </div>

        <div className="flex flex-col">
          <p className="text-gray-4 text-[15px] mb-2">Nov 2022</p>
          <p className="font-normal mb-2">
            Ranked 6th out of 75 Teams - 2022 UIT-VNU Hackathon
          </p>
          <p className="text-[15px] text-gray-4">
            Led a team of 4 to design and implement an environmental protection
            software application within 24 hours.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AwardMobile;
